var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"listitem"},[_c('img',{attrs:{"src":_vm.item.pic}}),_vm._v(" "),_c('div',{staticClass:"title"},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.item.productName))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189aca6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/listItemProduct.vue
// module id = null
// module chunks = 